import { useMemo, useState } from "react";
import Header from "../components/Header.jsx";
import Sidebar from "../components/Sidebar.jsx";
import Footer from "../components/Footer.jsx";
import AssistantWidget from "../components/AssistantWidget.jsx";
import { MyMediaUploadManager } from "../components/MyMediaUploadManager.jsx";
import { useAuth } from "../context/AuthContext.jsx";
import DraftPrompt from "../components/DraftPrompt.jsx";
import DraftPromptImagePreSelected from "../components/DraftPromptImagePreSelected.jsx";
import AppBanners from "../components/AppBanners.jsx";

export default function AppLayout({ children, currentPage = "" }) {
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth > 820);

  const { user, userMetaFacebook, userCategories, subscription } = useAuth();

  const isMobile = () => window.innerWidth <= 820;

  const toggleMenu = () => {
    setSidebarOpen((prev) => !prev);
  };

  const handleOverlayClick = () => {
    if (isMobile()) setSidebarOpen(false);
  };

  const userNiches = useMemo(() => {
    if (!Array.isArray(userCategories)) return "";
    return userCategories
      .filter((item) => item?.type === "doneforyou" || item?.type === "niche")
      .map((item) => item?.title)
      .filter(Boolean)
      .join(", ");
  }, [userCategories]);

  const userDestinations = useMemo(() => {
    if (!Array.isArray(userCategories)) return "";
    return userCategories
      .filter(
        (item) => item?.type === "destination" || item?.type === "country"
      )
      .map((item) => item?.title)
      .filter(Boolean)
      .join(", ");
  }, [userCategories]);

  const userTimeToPost =
    user?.timetopost || userMetaFacebook?.timetopost || "";

  return (
    <>
      <Header onToggleMenu={toggleMenu} />

      <div className="container-fluid">
        <div className="row">
          <Sidebar currentPage={currentPage} isOpen={sidebarOpen} />

          {/* Mobile overlay — closes sidebar when tapping outside */}
          {sidebarOpen && (
            <div
              className="d-block d-md-none position-fixed top-0 start-0 w-100 h-100"
              style={{ background: "rgba(0,0,0,0.3)" }}
              onClick={handleOverlayClick}
            />
          )}

          <main
            className={`${
              sidebarOpen ? "col-10 desktop" : "col-12"
            } main-content`}
          >
            <div className="container-fluid">
              <AppBanners />
              {children}
            </div>
          </main>
        </div>
      </div>

      <Footer className={sidebarOpen ? "desktop" : ""} />

            {user.limitedexperience == null && subscription ? (
      <AssistantWidget
        userId={user?.iduser || ""}
        userName={user?.name || ""}
        userNiches={userNiches}
        userDestinations={userDestinations}
        userTimeToPost={userTimeToPost}
      />
            ) : null}

      {/* Global upload manager — modals + hidden inputs, rendered once */}
      <MyMediaUploadManager />

      {/* Global post creator modal */}
      <DraftPrompt />

      <DraftPromptImagePreSelected />
    </>
  );
}